import React, { useEffect, useState } from "react";
import { Button, Form, Modal, Row, Col } from "react-bootstrap";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { updateEmployeeDetails } from "../Auth/action";
import { EMPLOYEES_API } from "../constants/urlConstants";
import { utilities } from "../components/utilities";

const EditEmployee = ({ staticData, employee, show, onHide }) => {
  const [formData, setFormData] = useState(employee);
  const dispatch = useDispatch();
  const employeeList = useSelector((s) => s.EmployeeListReducer.employeeList);

  // ✅ Dropdown options
  const competencyOptions = [
    { value: "", label: "Select" },
    ...staticData.filter((x) => x.type === "competency").map((x) => ({
      value: x.description,
      label: x.description,
    })),
  ];

  const bandOptions = [
    { value: "", label: "Select" },
    ...staticData.filter((x) => x.type === "band").map((x) => ({
      value: x.description,
      label: x.description,
    })),
  ];

  const teamOptions = [
    { value: "", label: "Select" },
    ...staticData.filter((x) => x.type === "team").map((x) => ({
      value: x.description,
      label: x.description,
    })),
  ];

  const roleOptions = [
    { value: "", label: "Select" },
    ...staticData.filter((x) => x.type === "role").map((x) => ({
      value: x.description,
      label: x.description,
    })),
  ];

  const geographyOptions = [
    { value: "", label: "Select" },
    { value: "India", label: "India" },
    { value: "Canada", label: "Canada" },
    { value: "US", label: "US" },
  ];

  useEffect(() => {
    if (employee) {
      let normalized = { ...employee };
      if (normalized.joining_date) {
        normalized.joining_date = normalized.joining_date.split("T")[0];
      }
      console.log(normalized);
      setFormData(normalized);
    }
  }, [employee]);

  const updateDetails = () => {
    const updated = { ...employee, ...formData };
    const index = employeeList.findIndex(
      (e) => e.employee_id.toUpperCase() === employee.employee_id.toUpperCase()
    );

    axios
      .put(`${EMPLOYEES_API}/updateuser`, updated)
      .then((res) => {
        if (res) {
          const newEmployeeList = [...employeeList];
          newEmployeeList[index] = updated;
          dispatch(updateEmployeeDetails(newEmployeeList));
          utilities.showToast("User Updated Successfully");
          onHide();
        }
      })
      .catch(() => utilities.showToast("Couldn't Update User!", true));
  };

  const handleChange = (field, value) =>
    setFormData({ ...formData, [field]: value });

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Employee</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form noValidate>
          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Employee ID</Form.Label>
                <Form.Control type="text" value={formData.employee_id || ""} readOnly />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Employee Name</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.employee_name || ""}
                  onChange={(e) => handleChange("employee_name", e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Email ID</Form.Label>
                <Form.Control
                  type="email"
                  value={formData.email_id || ""}
                  onChange={(e) => handleChange("email_id", e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Competency</Form.Label>
                <Form.Select
                  value={formData.competency || ""}
                  onChange={(e) => handleChange("competency", e.target.value)}
                >
                  {competencyOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Band</Form.Label>
                <Form.Select
                  value={formData.band_type || ""}
                  onChange={(e) => handleChange("band_type", e.target.value)}
                >
                  {bandOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Team</Form.Label>
                <Form.Select
                  value={formData.team || ""}
                  onChange={(e) => handleChange("team", e.target.value)}
                >
                  {teamOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Role</Form.Label>
                <Form.Select
                  value={formData.role_name || ""}
                  onChange={(e) => handleChange("role_name", e.target.value)}
                >
                  {roleOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Geography</Form.Label>
                <Form.Select
                  value={formData.geography || ""}
                  onChange={(e) => handleChange("geography", e.target.value)}
                >
                  {geographyOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Joining Date</Form.Label>
                <Form.Control
                  type="date"
                  value={formData.joining_date || ""}
                  onChange={(e) => handleChange("joining_date", e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Skill Set</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.skill_set || ""}
                  onChange={(e) => handleChange("skill_set", e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <Form.Group>
                <Form.Label>Secondary Skill Set</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.sec_skill_set || ""}
                  onChange={(e) => handleChange("sec_skill_set", e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Cancel</Button>
        <Button variant="primary" onClick={updateDetails}>Update</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditEmployee;
